import { useState, useEffect } from 'react';
import { projectsAPI } from '@/api/projects';

export type ProjectRole = 'owner' | 'editor' | 'viewer' | null;

export interface ProjectPermissions {
  role: ProjectRole;
  hasAccess: boolean;
  canEdit: boolean;
  canComplete: boolean;
  canUploadFiles: boolean;
  isLoading: boolean;
  error: string | null;
}

export const useProjectRole = (projectId: string): ProjectPermissions => {
  const [permissions, setPermissions] = useState<ProjectPermissions>({
    role: null,
    hasAccess: false,
    canEdit: false,
    canComplete: false,
    canUploadFiles: false,
    isLoading: true,
    error: null,
  });

  useEffect(() => {
    const fetchUserRole = async () => {
      if (!projectId) {
        setPermissions(prev => ({ ...prev, isLoading: false }));
        return;
      }

      try {
        setPermissions(prev => ({ ...prev, isLoading: true, error: null }));
        
        const roleData = await projectsAPI.getUserRoleForProject(projectId);
        
        setPermissions({
          role: roleData.role,
          hasAccess: roleData.hasAccess,
          canEdit: roleData.canEdit,
          canComplete: roleData.canComplete,
          canUploadFiles: roleData.canUploadFiles,
          isLoading: false,
          error: null,
        });
      } catch (error) {
        
        setPermissions({
          role: null,
          hasAccess: false,
          canEdit: false,
          canComplete: false,
          canUploadFiles: false,
          isLoading: false,
          error: error instanceof Error ? error.message : 'Rol bilgisi alınamadı',
        });
      }
    };

    fetchUserRole();
  }, [projectId]);

  return permissions;
}; 